<template>
  <div class="details">
    <!-- 头部:商品基本信息详情组件(child-event 回传详情数据) -->
    <div class="details_top">
      <div class="particulars">
        <particulars @child-event="parentEvent" ref="detail"></particulars>
      </div>
      <!-- 竞价信息与报价操作区 -->
      <div class="bidding_message">
        <!-- 竞价实时信息(status != 2 时显示) -->
        <div class="bidding_content" v-if="status != 2">
          <!-- <span style="font-size: 25px">竞价信息</span> -->
          <!-- 我参与的进行中加价详情时显示 -->
          <!-- 我参与的进行中加价详情时显示 -->
          <!-- ///////////////////////////////////////////////// -->
          <!-- 发布一开始和参与的详情使用 -->
          <!-- 当前最高价 + 倒计时(竞价进行中 status == 1) -->
          <div :class="listType === 0 ? 'message' : 'messages'" v-if="status == 1">
            <div>
              <span>当前最高价</span>
              <span>
                <span v-for="(item, index) in data.goodsCategoryList" :key="index">
                  <!-- {{ item.goodsName }}:<span style="color: #d0111a">￥</span> -->
                  <span style="color: #d0111a; font-size: 34px">{{ item.maxOrMinOfferPrice }}</span
                  >元/吨{{ index == data.goodsCategoryList.length - 1 ? "" : " | " }}
                </span>
              </span>
              <CountDown :endDate="`${data.residueTime}`" v-if="data.residueTime"></CountDown>
            </div>
            <div v-if="listType == 0" style="margin-right: 100px">
              <div
                v-if="listType == 0 && data.myOfferPric == ''"
                style="margin-top: 10px; font-size: 16px">
                暂无报价
              </div>
            </div>
            <!-- <div>
              <div>拍卖中</div>
              <div>{{ headertime}}</div>
            </div> -->
          </div>
          <!-- 发布一开始和参与的详情使用 -->

          <!-- 未中标提示(竞价结束未中标,保证金 1-2 工作日退回) -->
          <div
            class="loseabid"
            v-if="
              data.winningStatus == 0 && data.listType == 0 && data.tradeBidding.biddingStatus == 3
            ">
            <div class="loseabid_no">未中标</div>
            <div class="loseabid_size">保证金将在1-2工作日内退回至您的现金余额</div>
          </div>
          <!-- 、、、、、、、、未中标、、、、、、、 -->
        </div>
        <!-- 我参与的进行中加价 -->
        <!-- 报价操作区:数量/金额加减 + 提交按钮(进行中且非发布者 listType != 1) -->
        <div
          class="quote form-box"
          style="align-items: flex-start"
          v-if="status == 1 && listType != 1">
          <div>
            <div class="form">
              <el-form :model="ruleForm" ref="form" label-width="90px">
                <!-- 可供应数量加减(仅 selectTradeType==1 分支显示) -->
                <el-form-item
                  label="可供应数量"
                  label-width="100px"
                  prop="num"
                  v-if="selectTradeType == 1 && detailData.listType == 0"
                  class="offerPrice">
                  <i class="el-icon-minus" @click="subNum"></i>
                  <el-input
                    v-model="ruleForm.num"
                    maxlength="2100000000"
                    @input="formatData('num')"></el-input>
                  <i class="el-icon-plus" @click="addNum"></i>
                  <span>吨</span>
                </el-form-item>
                <!-- 报价金额列表(多商品逐项报价,按最低价差加减) -->
                <div v-for="(item, index) in ruleForm.offerDetailList" :key="index">
                  <el-form-item
                    :label="index == 0 ? '报价金额' : ''"
                    :prop="'offerDetailList.' + index + '.offerPrice'"
                    :rules="{
                      required: true,
                      message: '请输入报价金额',
                      trigger: 'blur',
                    }"
                    label-width="150px"
                    v-if="selectTradeType == 2 && detailData.listType == 0"
                    class="offerPrice">
                    <div class="offerPriceItem">
                      <!-- <span class="goodsName">{{ item.goodsName }}</span> -->
                      <i class="el-icon-minus" @click="sub(index)"></i>
                      <el-input v-model="ruleForm.offerDetailList[index].offerPrice"></el-input>
                      <i class="el-icon-plus" @click="add(index)"></i>
                      <span>元/吨</span>
                    </div>
                  </el-form-item>
                </div>
              </el-form>
            </div>
            <!-- 操作按钮:确认供应/立即报价/支付保证金/收藏 -->
            <div class="btn-wrap">
              <el-button
                class="add hy-btn"
                @click="createOrder"
                v-if="selectTradeType == 1 && detailData.listType == 0"
                >确认供应</el-button
              >
              <el-button
                class="add hy-btn"
                @click="openPayBond"
                v-if="selectTradeType == 2 && detailData.listType == 0 && payBond == 1"
                >立即报价</el-button
              >
              <el-button
                class="add hy-btn"
                @click="openPayBond"
                v-if="selectTradeType == 2 && detailData.listType == 0 && payBond == 0"
                >支付保证金</el-button
              >
              <el-button
                class="follow"
                icon="el-icon-plus"
                @click="follow"
                v-if="detailData.listType == 0 && detailData.followFlag == 0"
                >收藏商品</el-button
              >
              <el-button
                class="follow"
                icon="el-icon-plus"
                @click="follows"
                v-if="detailData.listType == 0 && detailData.followFlag == 1"
                >取消收藏</el-button
              >
            </div>

            <!-- <div class="quote_al">
            <div>报价金额</div>
            <div class="subtract">
              <el-input-number
                :min="0"
                v-model="num"
                :step="lowestDiffPrice"
              ></el-input-number>
              <div>最低加价幅度{{ num }}元</div>
            </div>
            <div>元/吨</div>
          </div>
          <div class="quote_btn">
            <div @click="follow" v-if="data.followFlag == 0">收藏商品</div>
            <div @click="follow" v-else>取消收藏</div>
            <div @click="openPayBond">立即报价</div>
          </div> -->
          </div>
          <!-- 最低加价提示(销售) -->
          <div
            v-if="selectTradeType == 2 && selectOrderType == 1"
            style="margin-left: 160px; color: red">
            <!-- 多商品竞价需要将竞价内所含商品均报价才算报价成功&nbsp;&nbsp;&nbsp;&nbsp; -->
            最低加价{{ detailData.tradeBidding.lowestDiffPrice }}元
          </div>
          <!-- 最低降价提示(采购) -->
          <div
            v-if="selectTradeType == 2 && selectOrderType == 2"
            style="margin-left: 160px; color: red">
            <!-- 多商品竞价需要将竞价内所含商品均报价才算报价成功&nbsp;&nbsp;&nbsp;&nbsp; -->
            最低降价{{ detailData.tradeBidding.lowestDiffPrice }}元
          </div>
        </div>

        <!-- 我参与的进行中加价 -->
      </div>
    </div>
    <!-- 竞价公司报价列表(已登录且认证后显示;进行中或有中标结果的定向场次仅参与方可见) -->
    <div
      class="company"
      v-if="
        (status == 1 || status == 2 || status == 3) &&
        computedLoginAndAuthentication &&
        canSeeOfferRecord
      ">
      <div class="company_list" style="display: flex; justify-content: space-between">
        <div>竞价公司</div>
        <div style="cursor: pointer" @click="flushClick">
          <i class="el-icon-refresh"></i>
        </div>
      </div>
      <div class="company_table">
        <el-table :data="tableData" border :span-method="objectSpanMethod" :cell-style="cellStyle">
          <el-table-column align="center" prop="companyName" label="竞价公司"> </el-table-column>
          <el-table-column align="center" prop="goodsName" label="竞价商品名称"> </el-table-column>
          <el-table-column align="center" prop="offerPrice" label="报价金额"> </el-table-column>
          <el-table-column align="center" prop="offerCount" label="报价数量(吨)"> </el-table-column>
          <el-table-column prop="createTime" align="center" label="报价时间"> </el-table-column>
          <el-table-column align="center" prop="winBidding" label="中标状态" width="180">
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 审核参与竞价企业列表(发布者且开启审核时显示) -->
    <div class="list" v-if="detailData.ifPublisher && detailData.tradeBidding.partNeedAudit == 1">
      <div class="t" style="display: flex; justify-content: space-between">
        <div>审核参与竞价企业</div>
        <div style="cursor: pointer" @click="listPartBidding">
          <i class="el-icon-refresh"></i>
        </div>
      </div>
      <el-table :data="partBiddingData" border style="width: 100%">
        <el-table-column align="center" prop="enterpriseName" label="竞价公司"> </el-table-column>
        <el-table-column align="center" prop="telephone" label="注册电话"> </el-table-column>
        <el-table-column prop="createTime" align="createTime" label="提交时间"> </el-table-column>
        <el-table-column align="center" prop="auditStatus" label="状态" width="180">
          <template slot-scope="scope">
            <div v-if="scope.row.auditStatus == 0">
              <div>待审核</div>
            </div>
            <div v-if="scope.row.auditStatus == 1">
              <div>审核通过</div>
            </div>
            <div v-if="scope.row.auditStatus == 2">
              <div>审核拒绝</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="winBidding" label="操作" width="180">
          <template slot-scope="scope">
            <el-button
              v-if="
                scope.row.auditStatus == 0 &&
                (detailData.tradeBidding?.biddingStatus == 0 ||
                  detailData.tradeBidding?.biddingStatus == 1)
              "
              @click="Approved(scope.row, 1)"
              type="text"
              size="small"
              >审核通过</el-button
            >
            <el-button
              v-if="
                scope.row.auditStatus == 0 &&
                (detailData.tradeBidding?.biddingStatus == 0 ||
                  detailData.tradeBidding?.biddingStatus == 1)
              "
              @click="Approved(scope.row, 2)"
              type="text"
              size="small"
              >审核拒绝</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 底部:竞价规则说明组件 -->
    <div class="details_bottom">
      <regulation class="regulation_bottom" :data="data"></regulation>
    </div>
  </div>
</template>

<script>
import particulars from "@/layout/particulars.vue";
import regulation from "@/layout/regulation.vue";
import { tradeOffer, reqBiddingTargeted } from "@/api/public.js";
import {
  reqIsPayBond,
  reqFollow,
  reqAddBiddingOffer,
  applyPartBidding,
  listPartBidding,
  auditPartBidding,
} from "@/api/hy";
import floatCompute from "@/utils/floatCompute.js";
// import CountDown from '@/components/countDown.vue'
import CountDown from "@/components/countDowns.vue";
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      /** 报价表单 */
      ruleForm: {
        /** 可供应数量(吨) */
        num: "",
        /** 报价明细列表(多商品逐项报价) */
        offerDetailList: [],
      },

      /** 倒计时显示文本(当前模板未展示) */
      headertime: null,
      /** 详情数据(子组件回传) */
      data: {},
      /** 底价暂存(当前未使用) */
      num: "",
      /** 报价表格数据 */
      tableData: [],
      /** 页面状态(路由传入,1=进行中) */
      status: this.$route.query.status,
      /** 倒计时累计毫秒 */
      time: 0,
      /** 定时器引用 */
      timer: "",
      /** 未使用 */
      timestamp: 0,
      /** 分页页码 */
      page: 1,
      /** 分页条数 */
      size: 10,
      /** 最低加价幅度 */
      lowestDiffPrice: 0,
      /** 未使用 */
      paybondShow: true,
      /** 列表来源(路由传入,0=我参与的详情) */
      listType: null,
      /** 详情数据(含 tradeBidding/goodsCategoryList) */
      detailData: {},
      /** 交易类型(固定 2 竞价;模板 ==1 分支不生效) */
      selectTradeType: 2,
      /** 订单类型:1 销售,2 采购(路由覆盖) */
      selectOrderType: null,
      /** 保证金状态:0 未支付,1 已支付 */
      payBond: 0,
      /** 审核企业列表 */
      partBiddingData: [],
      /** 报价记录是否可见:已出中标结果的定向场次仅参与方可见 */
      canSeeOfferRecord: true,
    };
  },
  components: {
    /** 商品基本信息详情组件 */
    particulars,
    /** 竞价规则说明组件 */
    regulation,
    /** 倒计时组件 */
    CountDown,
    // CountDown,
  },
  /** 初始化:拉取报价列表;从路由取 listType/selectOrderType */
  mounted() {
    this.getList();
    // console.log(this.$router.query.goodsId);
    this.listType = this.$route.query.listType;
    this.selectOrderType = this.$route.query.selectOrderType;
  },
  watch: {},

  computed: {
    ...mapState({
      /** vuex 用户登录认证提示信息 */
      massage: state => state.user.massage,
    }),
    /** 是否已登录且已认证(控制报价列表显示) */
    computedLoginAndAuthentication() {
      let status = this.massage == "未登录请前往登录" || this.massage == "请前往认证后操作";
      return !status;
    },
  },
  methods: {
    /** 审核参与竞价企业(type:1 通过,2 拒绝),成功后刷新列表 */
    Approved(row, type) {
      auditPartBidding({
        auditId: row.auditId,
        auditReason: "",
        auditStatus: type,
      }).then(res => {
        if (res.code == 0) {
          this.$message({
            type: "success",
            message: "审核成功",
          });
          this.listPartBidding();
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    /** 拉取参与竞价企业审核列表 */
    listPartBidding() {
      listPartBidding({
        biddingId: this.detailData.tradeBidding.biddingId,
      }).then(res => {
        if (res.code == 0) {
          this.partBiddingData = res.data;
          console.log(res.data, "listPartBidding");
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    /** 按指定字段计算合并行数(相同值连续的行合并) */
    mergeCol(id, rowIndex) {
      // debugger;
      // 合并单元格
      // id：属性名
      // rowIndex：行索引值
      var idName = this.tableData[rowIndex][id]; // 获取当前单元格的值
      if (rowIndex > 0) {
        // 判断是不是第一行
        // eslint-disable-next-line eqeqeq
        if (this.tableData[rowIndex][id] != this.tableData[rowIndex - 1][id]) {
          // 先判断当前单元格的值是不是和上一行的值相等
          var i = rowIndex;
          var num = 0; // 定义一个变量i，用于记录行索引值并进行循环，num用于计数
          while (i < this.tableData.length) {
            // 当索引值小于table的数组长度时，循环执行
            if (this.tableData[i][id] === idName) {
              // 判断循环的单元格的值是不是和当前行的值相等
              i++; // 如果相等，则索引值加1
              num++; // 合并的num计数加1
            } else {
              i = this.tableData.length; // 如果不相等，将索引值设置为table的数组长度，跳出循环
            }
          }
          return {
            rowspan: num, // 最终将合并的行数返回
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0, // 如果相等，则将rowspan设置为0
            colspan: 1,
          };
        }
      } else {
        // 如果是第一行，则直接返回
        let i = rowIndex;
        let num = 0;
        while (i < this.tableData.length) {
          // 当索引值小于table的数组长度时，循环执行
          if (this.tableData[i][id] === idName) {
            i++;
            num++;
          } else {
            i = this.tableData.length;
          }
        }
        return {
          rowspan: num,
          colspan: 1,
        };
      }
    },
    /** 报价列表第 0/4/5 列按 offerId 合并单元格 */
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 0 || columnIndex == 4 || columnIndex == 5) {
        return this.mergeCol("offerId", rowIndex);
      }
    },
    /** 可供应数量减 1(下限 0) */
    subNum() {
      this.ruleForm.num = floatCompute.floatSub(+this.ruleForm.num, 1);
      if (this.ruleForm.num <= 0) {
        this.ruleForm.num = 0;
      }
    },
    /** 取消收藏(二次确认后调接口,并刷新详情) */
    follows() {
      this.$confirm("是否要取消收藏?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          reqFollow({
            goodsId: this.$route.query.goodsId,
            type: 1,
          }).then(res => {
            if (res.code == 0) {
              this.$refs.detail.getlisst(this.$route.query.goodsId);
              this.$message({
                type: "success",
                message: "取消收藏成功!",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    /** 可供应数量加 1 */
    addNum() {
      this.ruleForm.num = floatCompute.floatAdd(+this.ruleForm.num, 1);
    },
    /** 报价金额减最低价差:竞价销售分支含底价/0 值边界保护,其余分支同样含 0 值保护 */
    sub(index) {
      let data = this.detailData.tradeBidding;
      if (this.$route.query.selectTradeType == 2 && this.$route.query.selectOrderType == 1) {
        if (this.ruleForm.offerDetailList[index].offerPrice <= 0) {
          this.ruleForm.offerDetailList[index].offerPrice = 0;
        } else if (
          this.ruleForm.offerDetailList[index].offerPrice ==
          this.ruleForm.offerDetailList[index].goodsPrice
        ) {
          this.ruleForm.offerDetailList[index].offerPrice =
            this.ruleForm.offerDetailList[index].goodsPrice;
        } else {
          this.ruleForm.offerDetailList[index].offerPrice -= data.lowestDiffPrice;
        }
      } else {
        if (this.ruleForm.offerDetailList[index].offerPrice - data.lowestDiffPrice <= 0) {
          this.ruleForm.offerDetailList[index].offerPrice = 0;
        } else if (this.ruleForm.offerDetailList[index].offerPrice <= 0) {
          this.ruleForm.offerDetailList[index].offerPrice = 0;
        } else if (
          this.ruleForm.offerDetailList[index].offerPrice <=
          this.ruleForm.offerDetailList[index].goodsPrice
        ) {
          this.ruleForm.offerDetailList[index].offerPrice =
            this.ruleForm.offerDetailList[index].offerPrice - data.lowestDiffPrice;
        }
      }
    },
    /** 报价金额加最低价差(注:非销售分支首条件 offerPrice+价差>=offerPrice 恒为真,总是直接设为底价,疑似笔误) */
    add(index) {
      let data = this.detailData.tradeBidding;
      if (this.$route.query.selectTradeType == 2 && this.$route.query.selectOrderType == 1) {
        this.ruleForm.offerDetailList[index].offerPrice += data.lowestDiffPrice;
      } else {
        if (
          this.ruleForm.offerDetailList[index].offerPrice + data.lowestDiffPrice >=
          this.ruleForm.offerDetailList[index].offerPrice
        ) {
          this.ruleForm.offerDetailList[index].offerPrice =
            this.ruleForm.offerDetailList[index].goodsPrice;
        } else if (
          this.ruleForm.offerDetailList[index].offerPrice >=
          this.ruleForm.offerDetailList[index].goodsPrice
        ) {
          this.ruleForm.offerDetailList[index].offerPrice =
            this.ruleForm.offerDetailList[index].goodsPrice;
        } else {
          this.ruleForm.offerDetailList[index].offerPrice =
            this.ruleForm.offerDetailList[index].offerPrice + data.lowestDiffPrice;
        }
      }
    },
    /** 刷新竞价公司报价列表 */
    flushClick() {
      this.getList();
    },
    /** 报价记录按商品明细展平为多行,0 价显示 *、其余加 ￥ 前缀 */
    formatTableDate(list) {
      if (!list || list.length == 0) {
        return [];
      }
      let newList = [];
      list.forEach(item => {
        item.offerDetailList.forEach(i => {
          if (i.offerPrice == 0) {
            i.offerPrice = "*";
          } else {
            i.offerPrice = "￥" + i.offerPrice;
          }
          newList.push({ ...item, ...i });
        });
      });
      return newList;
    },
    /** 校验报价记录可见性:竞价进行中(biddingStatus == 1)或已有中标结果(biddingStatus == 3)时,定向竞价仅参与方可见 */
    checkOfferRecordPermission() {
      let biddingStatus = this.detailData.tradeBidding?.biddingStatus;
      // 非进行中且未出中标结果(未开始/流拍/取消):维持可见
      if (biddingStatus != 1 && biddingStatus != 3) {
        this.canSeeOfferRecord = true;
        return;
      }
      reqBiddingTargeted(this.$route.query.goodsId)
        .then(res => {
          if (res.code != 0) {
            // 接口异常:保守处理,不可见
            this.canSeeOfferRecord = false;
            return;
          }
          /** biddingTargeted 是否定向竞价：0不开启 1开启
           * partiesFlag 是否参与方：0不是 1是
           */
          // 未开启定向竞价:公开可见
          if (res.data.biddingTargeted != 1) {
            this.canSeeOfferRecord = true;
            return;
          }
          // 开启定向竞价:仅参与方可见(企业审核中同样不可见,口径与公告详情侧 beforhandle 一致)
          this.canSeeOfferRecord = res.data.partiesFlag == 1 && this.massage == "";
        })
        .catch(() => {
          // 请求失败:保守处理,不可见
          this.canSeeOfferRecord = false;
        });
    },
    /** 拉取保证金状态与报价列表并格式化(中标状态/价格/时间) */
    getList() {
      // 步骤一:查询保证金支付状态
      reqIsPayBond(this.$route.query.goodsId).then(ret => {
        console.log(ret);
        this.payBond = ret.data.payBond;
      });
      // 步骤二:拉取报价列表并格式化展示字段
      let config = {
        page: this.page,
        size: this.size,
        goodsId: this.$route.query.goodsId,
      };
      tradeOffer(config).then(res => {
        let list = res.data.records;
        list.forEach(item => {
          if (item.winBidding == 0) {
            item.winBidding = "未中标";
          } else if (item.winBidding == 1) {
            item.winBidding = "中标";
          } else if (item.winBidding == -1) {
            item.winBidding = " ";
          }
          if (item.offerPrice == 0) {
            item.offerPrice = "*";
          } else {
            item.offerPrice = "￥" + item.offerPrice;
          }
          if (item.createTime) {
            item.createTime = item.createTime.replace("T", " ");
          }
        });
        this.tableData = this.formatTableDate(list);
        console.log(this.tableData);
      });
    },
    /** 收藏商品 */
    follow() {
      if (!this.beforhandle("personalCenter:auctionSale:partake:collect")) return;
      reqFollow({
        goodsId: this.$route.query.goodsId,
        type: 0,
      })
        .then(ret => {
          if (ret.code == 0) {
            this.$message({
              type: "success",
              message: "操作成功",
            });
            this.$refs.detail.getlisst(this.$route.query.goodsId);
          } else {
            this.$message({
              type: "error",
              message: ret.message,
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    /** 表头样式(当前模板未绑定) */
    headerCellStyle() {
      return "color:#333333;font-size:14px;height:45px;text-align:center;font-weight: 400;border:none;";
    },
    /** 单元格样式:公司列蓝字可点、中标/未中标着色 */
    cellStyle(column) {
      if (column.columnIndex == 0) {
        return "text-align:center;border-bottom:1px dashed #E5E5E5;color:#0458BF;cursor:pointer;";
      } else if (column.columnIndex == 1) {
        return "text-align:center;border-bottom:1px dashed #E5E5E5;";
      } else if (column.columnIndex == 4 && column.row.winBidding == "未中标") {
        return "text-align:center;border-bottom:1px dashed #E5E5E5;color:#FE6205";
      } else if (column.columnIndex == 4 && column.row.winBidding == "中标") {
        return "text-align:center;border-bottom:1px dashed #E5E5E5;color:#0458BF";
      } else {
        return "text-align:center;border-bottom:1px dashed #E5E5E5;";
      }
    },
    /** 立即报价/支付保证金:组装报价明细调接口,成功后刷新列表 */
    openPayBond() {
      if (!this.beforhandle("personalCenter:auctionSale:partake:offer")) return;
      let config = {
        goodsId: this.$route.query.goodsId,
        offerDetailList: this.ruleForm.offerDetailList.map(item => {
          return {
            categoryId: item.categoryId,
            offerPrice: item.offerPrice,
          };
        }),
      };
      reqAddBiddingOffer(config).then(res => {
        console.log(res);
        if (res.code == 1) {
          this.$message({
            type: "error",
            message: res.message,
          });
        } else {
          this.$message({
            type: "success",
            message: "操作成功",
          });
          // this.$refs.detail.getlisst(this.$route.query.goodsId);
          this.getList();
        }
      });
    },
    // biddingOffer() {
    //   this.$refs.form.validate((valid) => {
    //     if (valid) {
    //       if (this.submiting) return;
    //       this.submiting = true;
    //       reqAddBiddingOffer({
    //         goodsId: this.$route.query.goodsId,
    //         offerPrice: this.ruleForm.offerPrice,
    //       })
    //         .then((ret) => {
    //           if (ret.code == 0) {
    //             this.$message({
    //               type: "success",
    //               message: "操作成功",
    //             });
    //             this.$router.back(-1);
    //           } else {
    //             this.$message({
    //               type: "error",
    //               message: ret.message,
    //             });
    //           }
    //           this.submiting = false;
    //         })
    //         .catch((err) => {
    //           console.log(err);
    //         });
    //     } else {
    //       console.log("error submit!!");
    //       return false;
    //     }
    //   });
    // },
    /** 子组件详情回传:启动倒计时、初始化报价明细、拉取审核列表 */
    parentEvent(data) {
      // 步骤一:有剩余时间则启动倒计时
      if (data.residueTime > 0) {
        this.Djs_time();
      }
      this.detailData = data;
      console.log(this.detailData, "detailData");
      // 校验报价记录可见性(已出中标结果的定向场次仅参与方可见)
      this.checkOfferRecordPermission();
      // 步骤二:竞价交易时以底价初始化各商品报价明细
      if (this.$route.query.selectTradeType == 2) {
        this.ruleForm.offerDetailList = data.goodsCategoryList.map(item => {
          return {
            categoryId: item.categoryId,
            offerPrice: item.goodsPrice,
            goodsPrice: item.goodsPrice,
            goodsName: item.goodsName,
          };
        });
        console.log(this.ruleForm);
      }
      // 步骤三:记录最低加价幅度与底价,拉取审核列表
      if (data.tradeBidding) {
        this.lowestDiffPrice = data.tradeBidding.lowestDiffPrice;
        console.log(data);
        this.num = data.tradeBidding.floorPrice;
      }

      this.listPartBidding();
      this.data = data;
    },
    /** 毫秒时间戳转 HH:mm:ss */
    toHHmmss(value) {
      var time;
      let result = parseInt(value / 1000);
      let hours =
        Math.floor(result / 3600) < 10
          ? "0" + Math.floor(result / 3600)
          : Math.floor(result / 3600);
      let minutes =
        Math.floor((result / 60) % 60) < 10
          ? "0" + Math.floor((result / 60) % 60)
          : Math.floor((result / 60) % 60);
      let seconds =
        Math.floor(result % 60) < 10 ? "0" + Math.floor(result % 60) : Math.floor(result % 60);
      time = hours + ":" + minutes + ":" + seconds;
      return time;
    },
    /** 倒计时定时器:每秒累计并刷新剩余时间,归零后清理(注:timer 为局部变量,this.timer 恒为空串,返回上一页逻辑不触发) */
    Djs_time: function () {
      let _this = this;
      let timer = setInterval(() => {
        _this.time = _this.time + 1000;
        let a = _this.data.residueTime - _this.time;
        _this.headertime = _this.toHHmmss(a);
        if (a < 0) {
          clearInterval(timer);
          _this.timer = null;
        }
      }, 1000);
      if (_this.timer == null) {
        this.$router.go(-1);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.details {
  // padding: 20px;
  min-width: 1150px;
  width: 90%;
  margin: 0 auto;
  max-width: 1200px;
  background: white;

  .particulars {
    width: 100%;
    margin-top: 20px;
    // margin-left: 40px;
  }

  .details_bottom {
    margin-top: 20px;

    .regulation_bottom {
      // margin-left: 20px;
      width: 100%;
    }
  }

  .bidding_message {
    width: 100%;
    // margin-left: 20px;
    font-size: 20px;

    .bidding_content {
      // padding: 30px 50px;
      // border: 1px solid #ccc;
      // text-align: center;
      // height: 200px;
      width: 100%;
      min-height: 89px;
      background: #f8f8f8;
      line-height: 89px;
      padding-left: 15px;

      .message {
        display: flex;
        justify-content: space-between;
        margin-top: 40px;
      }

      .messages {
        display: flex;
        justify-content: space-between;
        margin-top: 40px;
      }

      .loseabid {
        margin-top: 50px;
        text-align: center;
        display: flex;

        .loseabid_no {
          margin-top: 20px;
          width: 100px;
          height: 50px;
          line-height: 50px;
          background: #ccc;
          color: black;
          font-weight: bolder;
        }

        .loseabid_size {
          margin-left: 20px;
          color: #d0111a;
        }

        // :nth-child(1) {
        //   margin: 0 auto;
        //   padding: 10px;
        //   width: 200px;
        //   background: #ccc;
        //   color: black;
        //   font-weight: bolder;
        // }
        // :nth-child(2) {
        //   font-size: 16px;
        //   margin-top: 10px;
        //   color: red;
        // }
      }
    }

    .quote {
      margin-top: 20px;
      padding: 30px 50px;
      border: 1px solid #ccc;
      // text-align: center;
      & > div {
        display: flex;
      }
      .quote_al {
        display: flex;
        // justify-content: space-between;
        justify-content: center;
        line-height: 40px;

        .subtract {
          margin: 0 10px;
          font-size: 15px;
          color: red;
        }
      }

      .quote_btn {
        display: flex;
        justify-content: space-between;
        margin-top: 10px;

        :nth-child(1) {
          border: 1px solid #ccc;
          padding: 10px;
          background: #ccc;
          font-weight: bolder;
        }

        :nth-child(2) {
          border: 1px solid #ccc;
          padding: 10px 80px;
          background: #ccc;
          font-weight: bolder;
        }
      }
    }
  }

  .company {
    margin: 20px 0;

    .company_list {
      font-size: 18px;
      background: #e5e5e5;
      height: 45px;
      line-height: 45px;
      padding-left: 22px;
      padding-right: 22px;
      color: #000;
    }
  }
  .list {
    margin: 20px 0;

    .t {
      font-size: 18px;
      background: #e5e5e5;
      height: 45px;
      line-height: 45px;
      padding-left: 22px;
      padding-right: 22px;
      padding: 0 22px;
      color: #000;
    }

    .el-table {
      border: 1px solid #ebebeb;
    }
  }
}

::v-deep .el-link--inner {
  font-size: 14px;
  line-height: 50px;
  height: 50px;
}

.goods-detail {
  width: 1200px;
  padding: 25px 20px;
  background: white;
  border: 1px solid #e5e5e5;
  margin: 15px auto;

  &::before,
  &::after {
    display: table;
    content: "";
  }
}

.info {
  flex: 1;
  padding: 20px;
  border: 1px solid #222;
}

.right {
  width: 300px;
  flex-shrink: 0;
  margin-left: 20px;
}

.release-info {
  font-size: 18px;

  .title {
    text-align: center;
    margin-bottom: 30px;
  }

  p {
    font-weight: bold;
    margin-bottom: 10px;
  }
}

.form-box {
  margin-top: 20px;
  background: #f7f7f7;
  // display: flex;
  // align-items: center;
  padding-top: 16px;

  .el-input {
    width: 100px;
  }
}

.form-box {
  .btn-wrap {
    .el-button {
      border-radius: 0;
      padding: 0;
      height: 40px;
    }

    .follow {
      padding: 0 5px;
      border-radius: 4px;
      height: 34px;
    }

    .add {
      width: 160px;
      border-radius: 4px;
      height: 34px;
      margin-left: 30px;
      margin-bottom: 16px;
    }
  }
}

.evaluate {
  margin-top: 40px;
}

.offerPrice {
  &::v-deep .el-input__inner {
    height: 36px !important;
    border-radius: 0;
  }

  i {
    display: inline-flex;
    height: 35px;
    width: 35px;
    align-items: center;
    justify-content: center;
    border: 1px solid #e5e5e5;
    box-sizing: border-box;
    cursor: pointer;
  }

  span {
    display: inline-block;
    margin-left: 5px;
  }
}

.hy-confirm::v-deep .el-message-box__container {
  width: 330px !important;
}

.el-pagination {
  text-align: right;
  margin-top: 10px;
}

.list {
  .t {
    border: 1px solid #e5e5e5;
    background: #f7f7f7;
    padding: 14px 22px;
    font-size: 18px;
  }

  .el-table {
    border: 1px solid #ebebeb;
  }
}

.rule {
  margin-top: 20px;
}
</style>
